import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = "/profile/myProfile";

// ✅ GET MY PROFILE
export const getMyProfile = createAsyncThunk(
  "profile/getMyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API_URL);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ✅ UPDATE PROFILE + CHANGE PASSWORD
export const updateMyProfile = createAsyncThunk(
  "profile/updateMyProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(API_URL, data);
      toast.success("تم تحديث البيانات بنجاح");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
